import { FetchHostURL } from "@/utils/fetchHostURL"
 console.log(window.location.hostname,'window')
//服务器地址
const HTTP_URL = 'https://hs-show-admin-dev.dindong.cn'//正式服
// const HTTP_URL = 'https://hs-show-admin-dev-test.dindong.cn'//测试服
// const HTTP_URL = 'http://127.0.0.1'

// 域名地址
const DOMAIN_URL='https://hs-show-admin-print.dindong.cn/'//正式服
// const DOMAIN_URL='http://hs-show-admin-print-test.dindong.cn/'//测试服
// const DOMAIN_URL='http://192.168.0.99:8080/'//本地

const FetchInstance = new FetchHostURL('127.0.0.1', '8888')

const GET_WEATHER_URL = 'https://tianqiapi.com/api/'

//const DEVICE_SOCKET_URL = "ws://127.0.0.1:8888/api/front"
const DEVICE_SOCKET_URL = FetchInstance.socketHostURL

//const DEVICE_HTTP_URL = "http://127.0.0.1:8888/api/"
const DEVICE_HTTP_URL = FetchInstance.deviceHostURL

//接口请求地址
const API_BASE_URL =  HTTP_URL + '/api/'


const UEDITOR_CONFIG = {
  // 编辑器不自动被内容撑高
  autoHeightEnabled: false,
  // 初始容器高度
  initialFrameHeight: 500,
  // 初始容器宽度
  initialFrameWidth: '100%',
  serverUrl: HTTP_URL + '/ueditor-php/controller.php',
  // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
  UEDITOR_HOME_URL: '/UEditor/',
  toolbars: [
    [
      'undo', 'redo', '|',
      'bold', 'italic', 'underline', 'strikethrough',
      'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor',
      'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
      'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
      'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
      'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
      'simpleupload', 'insertvideo', 'music',
      'horizontal', 'date', 'time',
      'inserttable','link'
    ]
  ],
  autoFloatEnabled: false,
  catchRemoteImageEnable: false,//设置是否抓取远程图片。不关闭这个会导致多次粘贴的时候，图片链接会被修改，导致图片丢失
}

export {
  HTTP_URL,
  API_BASE_URL,
  UEDITOR_CONFIG,
  DEVICE_SOCKET_URL,
  DEVICE_HTTP_URL,
  GET_WEATHER_URL,
  DOMAIN_URL
}
